<template>
  <div>
    <input
      ref="fileInput"
      type="file"
      multiple
      accept=".pdf,.doc,.docx,.xls,.xlsx,.png,.jpg,.jpeg"
      style="display: none"
      @change="onFileChange"
    />
    <b-button variant="outline-secondary" size="sm" @click="$refs.fileInput.click()" :disabled="isUploading">
      <i class="fa fa-paperclip" /> Bæta við skrá
    </b-button>
    <span v-if="isUploading" class="ml-2 text-muted">Hleður upp...</span>
    <ul v-if="uploadedFiles.length > 0" class="list-unstyled mt-2">
      <li v-for="f in uploadedFiles" :key="f.uuid" class="mb-1">
        <i class="fa fa-file" />
        <a v-if="f.url" :href="f.url" :download="f.filename" class="ml-1">{{ f.filename }}</a>
        <span v-else class="ml-1">{{ f.filename }}</span>
        <b-button variant="link" size="sm" class="text-danger p-0 ml-1" @click="removeAttachment(f.uuid)">
          <i class="fa fa-times" />
        </b-button>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import core from '@/api/core';

export default {
  name: 'email-attachment-upload',
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    initialFiles: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      uploadedFiles: [],
      uploadingCount: 0,
    };
  },
  computed: {
    isUploading() {
      return this.uploadingCount > 0;
    },
  },
  watch: {
    initialFiles(newVal) {
      this.uploadedFiles = [...newVal];
    },
    isUploading(newVal) {
      this.$emit('update:uploading', newVal);
    },
    value(newVal) {
      if (newVal.length === 0) {
        this.uploadedFiles = [];
      }
    },
  },
  methods: {
    async onFileChange(event) {
      const files = Array.from(event.target.files);
      this.$refs.fileInput.value = '';
      await Promise.all(files.map(file => this.uploadFile(file)));
    },
    async uploadFile(file) {
      this.uploadingCount += 1;
      try {
        const formData = new FormData();
        formData.append('file', file);
        const response = await core.emailUploadAttachment(formData);
        this.$emit('input', [...this.value, response.data.id]);
        this.uploadedFiles.push({ uuid: response.data.id, filename: response.data.filename, url: response.data.url });
      } catch (e) {
        this.$log.error(e);
        if (e.response && e.response.status === 413) {
          this.displayError(`Villa: Skráin er of stór. Hámarksstærð er 10 MB.`);
        } else if (e.response && e.response.status === 400 && e.response.data && e.response.data.file) {
          this.displayError(`Villa: ${e.response.data.file[0]}`);
        } else {
          this.displayError(`Óvænt villa við hleðslu skráar: ${file.name}`);
        }
      } finally {
        this.uploadingCount -= 1;
      }
    },
    removeAttachment(uuid) {
      this.$emit(
        'input',
        this.value.filter(id => id !== uuid),
      );
      this.uploadedFiles = this.uploadedFiles.filter(f => f.uuid !== uuid);
    },
    ...mapActions({
      displayError: 'displayError',
    }),
  },
};
</script>
